import jsPDF from 'jspdf';
import { NotaFiscal } from '../services/financialService';

// Formatação de valores em reais
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

// Formatação de data
export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR');
}

// Geração de PDF de Nota Fiscal
export function generateInvoicePDF(invoice: NotaFiscal): jsPDF {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 20;
  let yPos = margin;

  // Cabeçalho
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text('NOTA FISCAL DE SERVIÇOS', pageWidth / 2, yPos, { align: 'center' });
  yPos += 10;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Nº ${invoice.id}`, pageWidth / 2, yPos, { align: 'center' });
  yPos += 15;

  // Dados do Emitente (Nutricionista - prestador do serviço)
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('EMITENTE', margin, yPos);
  yPos += 7;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Nome: ${invoice.emitente.nome}`, margin, yPos);
  yPos += 6;

  if (invoice.emitente.cpf) {
    doc.text(`CPF: ${invoice.emitente.cpf}`, margin, yPos);
    yPos += 6;
  }

  if (invoice.emitente.cnpj) {
    doc.text(`CNPJ: ${invoice.emitente.cnpj}`, margin, yPos);
    yPos += 6;
  }

  if (invoice.emitente.endereco) {
    doc.text(`Endereço: ${invoice.emitente.endereco}`, margin, yPos);
    yPos += 6;
  }

  if (invoice.emitente.cidade && invoice.emitente.estado) {
    doc.text(
      `${invoice.emitente.cidade} - ${invoice.emitente.estado}`,
      margin,
      yPos
    );
    yPos += 6;
  }

  if (invoice.emitente.cep) {
    doc.text(`CEP: ${invoice.emitente.cep}`, margin, yPos);
    yPos += 6;
  }

  if (invoice.emitente.telefone) {
    doc.text(`Telefone: ${invoice.emitente.telefone}`, margin, yPos);
    yPos += 6;
  }

  if (invoice.emitente.email) {
    doc.text(`Email: ${invoice.emitente.email}`, margin, yPos);
    yPos += 6;
  }

  if (invoice.emitente.inscricaoEstadual) {
    doc.text(`Inscrição Estadual: ${invoice.emitente.inscricaoEstadual}`, margin, yPos);
    yPos += 6;
  }

  if (invoice.emitente.crn) {
    doc.text(`CRN: ${invoice.emitente.crn}`, margin, yPos);
    yPos += 6;
  }

  yPos += 5;

  // Linha divisória
  doc.setLineWidth(0.5);
  doc.line(margin, yPos, pageWidth - margin, yPos);
  yPos += 10;

  // Dados do Cliente (Paciente - destinatário do serviço)
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('CLIENTE', margin, yPos);
  yPos += 7;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Nome: ${invoice.cliente.nome}`, margin, yPos);
  yPos += 6;

  if (invoice.cliente.cpf) {
    doc.text(`CPF: ${invoice.cliente.cpf}`, margin, yPos);
    yPos += 6;
  }

  if (invoice.cliente.cnpj) {
    doc.text(`CNPJ: ${invoice.cliente.cnpj}`, margin, yPos);
    yPos += 6;
  }

  if (invoice.cliente.endereco) {
    doc.text(`Endereço: ${invoice.cliente.endereco}`, margin, yPos);
    yPos += 6;
  }

  if (invoice.cliente.cidade && invoice.cliente.estado) {
    doc.text(
      `${invoice.cliente.cidade} - ${invoice.cliente.estado}`,
      margin,
      yPos
    );
    yPos += 6;
  }

  if (invoice.cliente.cep) {
    doc.text(`CEP: ${invoice.cliente.cep}`, margin, yPos);
    yPos += 6;
  }

  if (invoice.cliente.telefone) {
    doc.text(`Telefone: ${invoice.cliente.telefone}`, margin, yPos);
    yPos += 6;
  }

  if (invoice.cliente.email) {
    doc.text(`Email: ${invoice.cliente.email}`, margin, yPos);
    yPos += 6;
  }

  yPos += 5;

  // Linha divisória
  doc.line(margin, yPos, pageWidth - margin, yPos);
  yPos += 10;

  // Dados do Serviço
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('DADOS DO SERVIÇO', margin, yPos);
  yPos += 7;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Data de Emissão: ${formatDate(invoice.dataEmissao)}`, margin, yPos);
  yPos += 6;

  if (invoice.dataVencimento) {
    doc.text(`Data de Vencimento: ${formatDate(invoice.dataVencimento)}`, margin, yPos);
    yPos += 6;
  }

  doc.text(`Descrição: ${invoice.descricaoServico}`, margin, yPos);
  yPos += 6;

  doc.setFont('helvetica', 'bold');
  doc.text(`Valor: ${formatCurrency(invoice.valor)}`, margin, yPos);
  yPos += 6;

  doc.setFont('helvetica', 'normal');
  doc.text(`Status: ${invoice.status.toUpperCase()}`, margin, yPos);
  yPos += 10;

  // Assinatura do Nutricionista
  if (invoice.assinatura?.nome || invoice.assinatura?.data) {
    doc.line(margin, yPos, pageWidth - margin, yPos);
    yPos += 10;

    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('ASSINATURA DO NUTRICIONISTA', margin, yPos);
    yPos += 10;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    if (invoice.assinatura.nome) {
      doc.text(`Nome: ${invoice.assinatura.nome}`, margin, yPos);
      yPos += 6;
    }

    if (invoice.assinatura.data) {
      doc.text(`Data: ${formatDate(invoice.assinatura.data)}`, margin, yPos);
      yPos += 6;
    }

    // Espaço para assinatura manual (linha)
    yPos += 10;
    doc.setLineWidth(0.5);
    doc.line(margin, yPos, pageWidth - margin, yPos);
    yPos += 15;
  }

  // Observações
  if (invoice.observacoes) {
    doc.line(margin, yPos, pageWidth - margin, yPos);
    yPos += 10;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('OBSERVAÇÕES', margin, yPos);
    yPos += 7;

    doc.setFont('helvetica', 'normal');
    const splitObservacoes = doc.splitTextToSize(
      invoice.observacoes,
      pageWidth - 2 * margin
    );
    doc.text(splitObservacoes, margin, yPos);
    yPos += splitObservacoes.length * 6;
  }

  // Rodapé
  const pageHeight = doc.internal.pageSize.getHeight();
  yPos = pageHeight - 30;

  doc.line(margin, yPos, pageWidth - margin, yPos);
  yPos += 10;

  doc.setFontSize(8);
  doc.setFont('helvetica', 'italic');
  doc.text(
    'Este documento foi gerado automaticamente pelo sistema NutriSync.',
    pageWidth / 2,
    yPos,
    { align: 'center' }
  );
  yPos += 5;

  doc.text(
    `Gerado em: ${formatDate(new Date().toISOString())}`,
    pageWidth / 2,
    yPos,
    { align: 'center' }
  );

  return doc;
}

// Geração de PDF de Relatório IR
export function generateIRReportPDF(
  receitas: Array<{
    periodo: string;
    total: number;
    consultas: number;
    media: number;
    detalhes: Array<{
      data: string;
      pacienteNome: string;
      valor: number;
      tipo: 'primeira' | 'retorno';
    }>;
  }>,
  year: number
): jsPDF {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 20;
  let yPos = margin;

  // Cabeçalho
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text('RELATÓRIO DE RECEITAS PARA IR', pageWidth / 2, yPos, {
    align: 'center',
  });
  yPos += 7;

  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  doc.text(`Ano: ${year}`, pageWidth / 2, yPos, { align: 'center' });
  yPos += 15;

  // Resumo por mês
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('RESUMO POR MÊS', margin, yPos);
  yPos += 10;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('Mês', margin, yPos);
  doc.text('Total', margin + 60, yPos);
  doc.text('Consultas', margin + 100, yPos);
  doc.text('Média', margin + 150, yPos);
  yPos += 7;

  doc.setFont('helvetica', 'normal');
  doc.setLineWidth(0.5);
  doc.line(margin, yPos - 2, pageWidth - margin, yPos - 2);

  let totalGeral = 0;
  let totalConsultas = 0;

  receitas.forEach((receita) => {
    if (yPos > 250) {
      doc.addPage();
      yPos = margin;
    }

    const month = receita.periodo.split('-')[1];
    const monthNames = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ];
    const monthName = monthNames[parseInt(month) - 1];

    doc.text(monthName, margin, yPos);
    doc.text(formatCurrency(receita.total), margin + 60, yPos);
    doc.text(receita.consultas.toString(), margin + 100, yPos);
    doc.text(formatCurrency(receita.media), margin + 150, yPos);
    yPos += 7;

    totalGeral += receita.total;
    totalConsultas += receita.consultas;
  });

  yPos += 5;
  doc.line(margin, yPos, pageWidth - margin, yPos);
  yPos += 7;

  doc.setFont('helvetica', 'bold');
  doc.text('TOTAL GERAL', margin, yPos);
  doc.text(formatCurrency(totalGeral), margin + 60, yPos);
  doc.text(totalConsultas.toString(), margin + 100, yPos);
  doc.text(
    formatCurrency(totalConsultas > 0 ? totalGeral / totalConsultas : 0),
    margin + 150,
    yPos
  );
  yPos += 15;

  // Detalhamento
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('DETALHAMENTO', margin, yPos);
  yPos += 10;

  receitas.forEach((receita) => {
    const [year, month] = receita.periodo.split('-');
    const monthNames = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ];
    const monthName = monthNames[parseInt(month) - 1];

    if (yPos > 250) {
      doc.addPage();
      yPos = margin;
    }

    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text(`${monthName}/${year}`, margin, yPos);
    yPos += 7;

    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text('Data', margin, yPos);
    doc.text('Paciente', margin + 50, yPos);
    doc.text('Tipo', margin + 120, yPos);
    doc.text('Valor', margin + 160, yPos);
    yPos += 6;

    doc.setFont('helvetica', 'normal');
    doc.setLineWidth(0.3);
    doc.line(margin, yPos - 2, pageWidth - margin, yPos - 2);

    receita.detalhes.forEach((detalhe) => {
      if (yPos > 250) {
        doc.addPage();
        yPos = margin;
      }

      doc.text(formatDate(detalhe.data), margin, yPos);
      doc.text(detalhe.pacienteNome, margin + 50, yPos, {
        maxWidth: 60,
      });
      doc.text(
        detalhe.tipo === 'primeira' ? 'Primeira' : 'Retorno',
        margin + 120,
        yPos
      );
      doc.text(formatCurrency(detalhe.valor), margin + 160, yPos);
      yPos += 6;
    });

    yPos += 5;
  });

  // Rodapé
  const pageHeight = doc.internal.pageSize.getHeight();
  yPos = pageHeight - 20;

  doc.setFontSize(8);
  doc.setFont('helvetica', 'italic');
  doc.text(
    `Gerado em: ${formatDate(new Date().toISOString())}`,
    pageWidth / 2,
    yPos,
    { align: 'center' }
  );

  return doc;
}
